import SBlogDetails from "./SBlogDetails_web"
export default SBlogDetails
